import React from 'react';
import { Badge } from '@mantine/core';
import * as App from "./../../model/App";

export interface ITableDaysRemainingCellProps {
    daysRemaining: number;
    daysRemainingOverrideMessage: string;
}

export default function TableDaysRemainingCell(props: ITableDaysRemainingCellProps) {
    let badgeColor = "gray";
    if (props.daysRemaining <= 7) { badgeColor = "red"; }
    else if (props.daysRemaining <= 30) { badgeColor = "orange"; }

    // Format days remaining message...
    let daysRemainingMessage = "";
    if (props.daysRemainingOverrideMessage) { daysRemainingMessage = props.daysRemainingOverrideMessage; }
    else if (props.daysRemaining <= 0) { daysRemainingMessage = "Overdue"; }
    else if (props.daysRemaining > 365) { daysRemainingMessage = getYearsMonthsRemainingMessage(props.daysRemaining); }
    else { daysRemainingMessage = `${props.daysRemaining} ${props.daysRemaining === 1 ? "day" : "days"}`; }

    return <Badge color={badgeColor}>{daysRemainingMessage}</Badge>;
}

/** 
     * Returns a message like "~# years, # months" 
     * This is just an approximation, so if there are a only days remaining or negative days, it will return "".
    */
 function getYearsMonthsRemainingMessage(numDaysRemaining: number): string {
    // Negative time, return nothing...
    if (numDaysRemaining <= 0) { return ""; }

    // Calculate (approximately) how many years/months/days are remaining...
    let remainder = 0;
    const numYears = Math.floor(numDaysRemaining / 365);
    remainder = numDaysRemaining % 365;
    const numMonths = Math.floor(remainder / 30);
    remainder = remainder % 30;

    // If only days remaining, return ""...
    if (numYears <= 0 && numMonths <= 0) { return ""; }

    // Convert to a string...
    let s = "~";
    if (numYears > 0) { s += numYears.toLocaleString() + "y"; }
    if (numYears > 0 && numMonths > 0) { s += ", "; }
    if (numMonths > 0) { s += numMonths.toLocaleString() + "m"; }
    return s;
}